import { useEffect, useState } from "react";
import { AdaptiveDpr, AdaptiveEvents, OrbitControls } from "@react-three/drei";
import GPGPUParticles from "./Components/Background/GPGPUParticles.jsx";
import useMainContentTab from "./stores/useMainContentTab.jsx";
import gsap from "gsap";

export default function Experience() {
    const { mainContentTab } = useMainContentTab();
    const [autoRotateSpeed, setAutoRotateSpeed] = useState(0.2);

    useEffect(() => {
        const targetSpeed = mainContentTab === "ThankyouScreen" ? 0.001 : 0.1;
        gsap.to({ value: autoRotateSpeed }, {
            value: targetSpeed,
            duration: 1,
            ease: "sine.inOut",
            onUpdate: function() {
                setAutoRotateSpeed(this.targets()[0].value);
            }
        });
    }, [mainContentTab]);

    return (
        <>
            <AdaptiveDpr pixelated />
            <AdaptiveEvents />
            <OrbitControls
                autoRotate
                autoRotateSpeed={autoRotateSpeed}
                enablePan={false}
                makeDefault
            />
            <GPGPUParticles />
        </>
    );
}

